import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class ApiService {
  constructor(private http: HttpClient) {}

  public setApiUrl(url: string) {
    if (url) {
      localStorage.setItem('apiUrl', JSON.stringify({ url: url }));
    }
  }

  public getApiUrl(): any {
    return localStorage.getItem('apiUrl') ? JSON.parse(localStorage.getItem('apiUrl')) : null;
  }

  public deleteElement(route: string, elementId: number): Observable<any> {
    return this.http.delete<any>(`${route}/${elementId}`);
  }
}
